<template>
	<div class="d-flex justify-end align-center order-0 order-sm-1" style="min-width:168px;gap: 5px;">
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					class="topbar-action-btn"
					dark
					x-small
					color="#2D4B95"
					v-bind="attrs"
					v-on="on"
					:loading="loadingPDFDownload"
					@click="$emit('download-pdf')"
				>
					<v-icon dark>mdi-file-pdf-box</v-icon>
				</v-btn>
			</template>
			<span>Descargar en PDF</span>
		</v-tooltip>

		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					class="topbar-action-btn"
					dark
					x-small
					color="#2D4B95"
					v-bind="attrs"
					v-on="on"
					:loading="loadingFilePath"
					@click="downloadAttachments"
				>
					<v-icon dark small>mdi-download</v-icon>
				</v-btn>
			</template>
			<span>Descargar Adjuntos</span>
		</v-tooltip>

		<v-btn class="topbar-action-btn" dark x-small color="#fb8c00" @click="$emit('minimize')">
			<v-icon dark small>mdi-window-minimize</v-icon>
		</v-btn>

		<CloseNotificationButton
			:notification="currentEntrega.active_notification"
			:closeModal="() => $emit('close')"
		/>

		<v-btn class="topbar-action-btn big" dark small color="#F4516C" @click="$emit('close')">
			<v-icon dark small>mdi-close</v-icon>
		</v-btn>

		<SendContentByEmailModal
			:sendContentByEmailModal="sendByEmailModal"
			:closeModal="() => (sendByEmailModal = false)"
			:sendingType="2"
		/>
	</div>
</template>

<script>
import {getZippedFiles, getZippedFilesByItem} from '@/helpers/api/fileUploads'
import SendContentByEmailModal from '@/components/Globals/Modals/General/SendContentByEmailModal'
import CloseNotificationButton from '@/components/Globals/Modals/General/CloseNotificationButton'

export default {
	name: 'HeaderButtons',
	components: { SendContentByEmailModal, CloseNotificationButton },
  computed: {
    currentEntrega() {
      return this.$store.entregaStore.state.currentEntrega || {};
    },
	},
	data: () => ({
		sendByEmailModal: false,
		loadingPDFDownload: false,
		loadingFilePath: false
	}),
	methods: {
		async downloadAttachments(){
			this.loadingFilePath = true
			let item = this.currentTarea || this.currentRDI || this.currentAdicional || this.currentEntrega
			let toZip = []
			if(!item){ this.loadingFilePath = false; return }
			if(item.revisions){
				item.revisions.forEach(r => { if(r.attachments) toZip.push(...r.attachments.map(a => a.file || a.attachment || a)) })
			}
			if(item.attachments){ toZip.push(...item.attachments.map(a => a.file || a.attachment || a)) }
			if(item.interactions){ item.interactions.forEach(i => { if(i.attachments) toZip.push(...i.attachments.map(a => a.file || a.attachment || a)) }) }
			try{
				// Preferir endpoint por item cuando esté disponible
				let files = null
				const entrega = this.currentEntrega
				if (entrega && entrega.id) {
					files = await getZippedFilesByItem({ entrega_id: entrega.id })
				}
				if (!files) {
					files = await getZippedFiles({ files_to_zip: toZip })
				}
				if(files && files.code == 200 && files.fileurl) window.open(files.fileurl)
				else if(files && files.job_id){
					const data = {
						message: 'La descarga se está preparando. Recibirás un correo con el enlace cuando esté lista.',
						title: 'Descarga de archivos',
						created: new Date(),
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.$store.globalStore.dispatch('addMessage', data)
				}
			} catch(e){ console.error(e) }
			this.loadingFilePath = false
		},
	}
}
</script>

<style scoped>
	.bg-light-blue-text {
		background-color: #5E85EF;
	}

	.icon-top {
		padding: 2px;
		margin: 0 2px;
		border-radius: 100%;
		width: 30px;
		height: 30px;
		cursor: pointer;
	}

	.high--text {
		color: #F4516C !important;
		caret-color: #F4516C !important;
	}

	.high {
		background-color: #F4516C !important;
		border-color: #F4516C !important;
		color: white;
	}
	.topbar-action-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 24px!important;
		padding: 5px!important;
		min-width: 28px!important;
		aspect-ratio: 1!important;
		border-radius: 6px;
		border: none;
		cursor: pointer;
		transition: opacity 0.15s;
	}
	.topbar-action-btn.big{
		height: 30px!important;
		min-width: 30px!important;
	}
</style>